import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=3807e362&scoped=true&"
import script from "./UserCard.vue?vue&type=script&lang=js&"
export * from "./UserCard.vue?vue&type=script&lang=js&"
import style0 from "./UserCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserCard.vue?vue&type=style&index=1&id=3807e362&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807e362",
  null
  
)

export default component.exports